export const FROM_SOURCE = {
  MAJOR: 'major', // 专业页
  MY_WORKS: 'myWorks', // 我的作品列表页
  // 可扩展其他来源（如首页：HOME = 'home'）
};